/**
 * Brand Configuration
 * 
 * Centralized configuration for whitelabel branding in the frontend.
 * All branding-related values are loaded from environment variables.
 * 
 * This configuration is used throughout the application for:
 * - Page titles and metadata
 * - Company contact information
 * - Theme colors
 * - Footer branding
 * - Header/logo branding
 * 
 * NOTE: React environment variables are embedded at build time.
 * Any changes require a rebuild of the application.
 */

export interface BrandConfig {
  appName: string;
  apiUrl: string;
  companyEmail: string;
  colors: {
    primary: string;
    secondary: string;
  };
  prodUrl: string;
}

export const brandConfig: BrandConfig = {
  // Application Name
  appName: process.env.REACT_APP_NAME || 'SOD Tix',
  
  // Backend API URL (supports both new and legacy env variable names)
  apiUrl: process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || 'http://localhost:3001',
  
  // Company Email
  companyEmail: process.env.REACT_APP_COMPANY_EMAIL || 'hello@sodtix.com',
  
  // Brand Colors
  colors: {
    primary: process.env.REACT_APP_PRIMARY_COLOR || 'rgba(0, 85, 137, 255)',
    secondary: process.env.REACT_APP_SECONDARY_COLOR || '#3C3C3C',
  },
  prodUrl: process.env.REACT_APP_URL || 'www.sodtix.com'
};

// Helper functions
export const getBrandYear = (): number => new Date().getFullYear();

export const getCopyrightText = (): string => {
  return `© ${getBrandYear()} ${brandConfig.appName}. All rights reserved.`;
};

// Export as default for compatibility
export default brandConfig;
